// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"f6a35cdc","453":"08def7b7"}[chunkId] + ".chunk.js";
};